export default __webpack_public_path__ + "static/media/imagem-grid-1.67389fc2.png";